import Contenedor from '../../../components/common/Contenedor';
import { Menu } from './menu';

export const ModuloCortesHotel = () => {
  return (
    <Contenedor title="Modulo de Cortes" children={<Menu />} />
  )
}
